import { render, staticRenderFns } from "./CustomerDetailPopUp.vue?vue&type=template&id=0616c771&scoped=true&"
import script from "./CustomerDetailPopUp.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailPopUp.vue?vue&type=style&index=0&id=0616c771&scoped=true&lang=css&"
import style1 from "./CustomerDetailPopUp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616c771",
  null
  
)

export default component.exports